import { render } from "./SaleItem.vue?vue&type=template&id=13778f22&scoped=true"
import script from "./SaleItem.vue?vue&type=script&lang=js"
export * from "./SaleItem.vue?vue&type=script&lang=js"

import "./SaleItem.vue?vue&type=style&index=0&id=13778f22&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13778f22"]])

export default __exports__